define(
    'providers/dataprovider.signurl',[
        "services/config"
    ],
    function (config) {
        function retry(data) {
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "pos-signurl-retry",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function addFile(data) {
            data.revision = !data.revision ? "" : "/" + data.revision;

    		return $.Deferred(function (deferred) {
    			amplify.request({
    				resourceId: "put-signurl-addfile",
    				data: data,
    				success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    				error: function (result, statusCode) { deferred.reject(result, statusCode); }
    			});
    		}).promise();
        }

        function addShareFolderFile(data) {
            data.documentId = !data.documentId ? "" : "/" + data.documentId;

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-signurl-addshare-folder-file",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function checkinFile(data) {
            data.revision = !data.revision ? "" : "/" + data.revision;

    		return $.Deferred(function (deferred) {
    			amplify.request({
    				resourceId: "put-signurl-checkinfile",
    				data: data,
    				success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    				error: function (result, statusCode) { deferred.reject(result, statusCode); }
    			});
    		}).promise();
    	}

    	function replaceFile(data) {
    	    data.revision = !data.revision ? "" : "/" + data.revision;

    		return $.Deferred(function (deferred) {
    			amplify.request({
    				resourceId: "put-signurl-replacefile",
    				data: data,
    				success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    				error: function (result, statusCode) { deferred.reject(result, statusCode); }
    			});
    		}).promise();
    	}

    	function updateFile(data) {
    	    data.revision = !data.revision ? "" : "/" + data.revision;

    		return $.Deferred(function (deferred) {
    			amplify.request({
    				resourceId: "put-signurl-updatecontent",
    				data: data,
    				success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    				error: function (result, statusCode) { deferred.reject(result, statusCode); }
    			});
    		}).promise();
    	}

    	function uploadFileAsVersion(data) {
    	    data.revision = !data.revision ? "" : "/" + data.revision;

    		return $.Deferred(function (deferred) {
    			amplify.request({
    				resourceId: "pos-signurl-uploadfileasversion",
    				data: data,
    				success: function (result, statusCode) { deferred.resolve(result, statusCode); },
    				error: function (result, statusCode) { deferred.reject(result, statusCode); }
    			});
    		}).promise();
    	}

    	init();

    	return {
    	    retry: retry,
    	    addFile: addFile,
    	    addShareFolderFile: addShareFolderFile,
    		checkinFile: checkinFile,
    		replaceFile: replaceFile,
    		updateFile: updateFile,
			uploadFileAsVersion: uploadFileAsVersion
    	};

    	//#region Internal Methods

    	function init() {
    	    amplify.request.define("pos-signurl-retry", "ajax", {
    	        url: getUrl("documents/actionretry/getputurl/{documentId}"),
    	        contentType: "application/json",
    	        dataType: "json",
    	        type: "PUT",
    	        dataMap: function (data) {
    	            return JSON.stringify(data);
    	        }
    	    });

    		amplify.request.define("put-signurl-addfile", "ajax", {
    			url: getUrl("documents/{action}/add/{id}{revision}"),
    			contentType: "application/json",
    			dataType: "json",
    			type: "PUT",
    			dataMap: function (data) {
    				return JSON.stringify(data);
    			}
    		});

    		amplify.request.define("put-signurl-addshare-folder-file", "ajax", {
    		    url: getUrl("foldershares/folderlink/{action}/{linkId}{documentId}"),
    		    contentType: "application/json",
    		    dataType: "json",
    		    type: "PUT",
    		    dataMap: function (data) {
    		        return JSON.stringify(data);
    		    }
    		});

    		amplify.request.define("put-signurl-checkinfile", "ajax", {
    		    url: getUrl("documents/{action}/checkin/{documentId}{revision}"),
    			contentType: "application/json",
    			dataType: "json",
    			type: "PUT",
    			dataMap: function (data) {
    				return JSON.stringify(data);
    			}
    		});

    		amplify.request.define("put-signurl-replacefile", "ajax", {
    		    url: getUrl("documents/{action}/replace/{documentId}{revision}"),
    			contentType: "application/json",
    			dataType: "json",
    			type: "PUT",
    			dataMap: function (data) {
    				return JSON.stringify(data);
    			}
    		});

    		amplify.request.define("put-signurl-updatecontent", "ajax", {
    		    url: getUrl("documents/{action}/updatecontent/{documentId}{revision}"),
    			contentType: "application/json",
    			dataType: "json",
    			type: "PUT",
    			dataMap: function (data) {
    				return JSON.stringify(data);
    			}
    		});

    		amplify.request.define("pos-signurl-uploadfileasversion", "ajax", {
    		    url: getUrl("documents/{action}/uploadnewversion/{documentId}"),
    			contentType: "application/json",
    			dataType: "json",
    			type: "PUT",
    			dataMap: function (data) {
    				return JSON.stringify(data);
    			}
    		});
    	}

    	function getUrl(action) {
    		return config.webApiUrl + action;
    	}

    	//#endregion
    }
);
